import { useEffect } from 'react';
import WebViewMessageManager from '../utils/webViewMessageManager';

const useWebViewMessages = <T = unknown>(handler: (message: T, rawEvent: MessageEvent<string>) => void): void => {
  useEffect(() => {
    const manager = WebViewMessageManager.getInstance();
    const unsubscribe = manager.addListener((event: MessageEvent<string>) => {
      try {
        if (typeof event.data !== 'string') return;
        const webviewMessage = JSON.parse(event.data) as T;
        handler(webviewMessage, event);
      } catch (err) {
        console.error('WebView message parse error:', err);
      }
    });

    return unsubscribe;
  }, [handler]);
};

export default useWebViewMessages;
